import { Analytic } from '@ads-platform/web-wba-analytic-events/generated-events/campaigns';
import { metrics } from '@wba/web-sdk';

type TAC = (eventFileName: string, props: Record<string, any>, eventJson?: Record<string, string>) => void;

interface IJSONResponseAnalytics {
    id: string,
    errors?: Array<{ message: string }>
}

function getUserIdAnalytics() {
    if(window.IS_PROD === 'false') {
        return Promise.resolve({ id: localStorage.getItem('qa-supplier-old-id') ?? '' });
    }
    const url = '/api/v5/analyst-info'; // Эта ручка есть в контракте
    const token = localStorage.getItem(String(import.meta.env.APP_ACCESS_TOKEN_KEY)) ?? '';

    return fetch(url, {
        headers: {
            'AuthorizeV3': token
        }
    })
        .then((response) => {
            if(!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            return response.json();
        })
        .then((response: IJSONResponseAnalytics) => response)
        .catch((error) => {
            console.error((error as Error).message);

            return { id: '0' };
        });
}

void getUserIdAnalytics().then(({ id: currentSupplierId }) => {
    metrics.userId = currentSupplierId;
    metrics.counterId = Number(window.APP_COUNTER_ID_SDK);
    metrics.init();
});

// eslint-disable-next-line max-len
const transportCallback: TAC = (eventFileName, props, eventJson) => metrics.HandleSimpleEvent(eventJson?.title || eventFileName, props);

export const analyticSDK = new Analytic(transportCallback);
